{
  "login": "உள்நுழைவு",
  "logout": "வெளியேறு",
  "signOut": "வெளியேறு",
  "username": "பயனர் பெயர்",
  "password": "கடவுச்சொல்",
  "forgotPassword": "கடவுச்சொல்லை மறந்தீர்களா?",
  "rememberMe": "என்னை நினைவில் கொள்",
  "loginButton": "உள்நுழை",
  "loginError": "தவறான பயனர் பெயர் அல்லது கடவுச்சொல்",
  "sessionExpired": "உங்கள் அமர்வு காலாவதியாகிவிட்டது. மீண்டும் உள்நுழையவும்.",
  "passwordChangedRelogin": "Your password was changed. Please sign in with your new password.",
  "signingIn": "உள்நுழைகிறது...",
  "loginSuccess": "வெற்றிகரமாக உள்நுழைந்தது",
  "showPassword": "கடவுச்சொல்லைக் காட்டு",
  "hidePassword": "கடவுச்சொல்லை மறை",
  "onboardingPrompt": "உங்கள் மருத்துவமனை அல்லது மருத்துவ மையத்திற்காகவா?",
  "onboardingCta": "சேர்க்கையை கோருங்கள்",
  "loginFailed": "உள்நுழைவு தோல்வியடைந்தது",
  "seatCapReached": "இந்த உரிமத்திற்கான பயனர் வரம்பு எட்டப்பட்டது. உங்கள் நிர்வாகியைத் தொடர்பு கொள்ளவும்.",
  "mfaCodeLabel": "சரிபார்ப்புக் குறியீடு",
  "mfaCodePrompt": "உள்நுழைவை முடிக்க உங்கள் அங்கீகரிப்பு பயன்பாட்டிலிருந்து 6 இலக்கக் குறியீட்டை உள்ளிடவும்.",
  "mfaSetupRequired": "உங்கள் நிறுவனம் பல காரணி அங்கீகாரத்தைக் கட்டாயமாக்குகிறது. தொடர உங்கள் அங்கீகரிப்புச் செயலியை அமைக்கவும்.",
  "mfaCodePlaceholder": "6 இலக்கக் குறியீடு",
  "mfaInvalidCode": "தவறான சரிபார்ப்புக் குறியீடு",
  "pages": {
    "userProfile": {
      "title": "எனது சுயவிவரம்",
      "loading": "சுயவிவரம் ஏற்றப்படுகிறது...",
      "sections": {
        "profilePicture": "சுயவிவர படம்",
        "personalInformation": "தனிப்பட்ட தகவல்",
        "changePassword": "கடவுச்சொல்லை மாற்று",
        "multiFactorAuth": "பல-காரணி அங்கீகாரம்"
      },
      "fields": {
        "fullName": "முழுப் பெயர்",
        "email": "மின்னஞ்சல்",
        "phone": "தொலைபேசி",
        "currentPassword": "தற்போதைய கடவுச்சொல்",
        "newPassword": "புதிய கடவுச்சொல்",
        "confirmPassword": "புதிய கடவுச்சொல்லை உறுதிப்படுத்து",
        "required": "*"
      },
      "actions": {
        "saveChanges": "மாற்றங்களைச் சேமி",
        "changePassword": "கடவுச்சொல்லை மாற்று",
        "setUpMfa": "பல-காரணி அங்கீகாரத்தை அமை",
        "uploadAvatar": "பதிவேற்று",
        "changeAvatar": "மாற்று",
        "removeAvatar": "அகற்று",
        "verify": "சரிபார்"
      },
      "avatar": {
        "alt": "அவதார்",
        "helperText": "PNG, JPEG அல்லது WebP, 4 MB வரை. பதிவேற்றுவதற்கு முன் {{size}}×{{size}} அளவுக்கு மாற்றப்படும்."
      },
      "mfa": {
        "enabledMessage": "உங்கள் கணக்கில் பல-காரணி அங்கீகாரம் இயக்கப்பட்டுள்ளது.",
        "intro": "உங்கள் கணக்கின் பாதுகாப்பிற்கு கூடுதல் அடுக்கைச் சேர்க்க பல-காரணி அங்கீகாரத்தை இயக்கவும்.",
        "scanInstruction": "உங்கள் அங்கீகார பயன்பாட்டில் இந்த URI-ஐ ஸ்கேன் செய்யவும், அல்லது கைமுறையாக நகலெடுக்கவும்:",
        "copyUri": "URI-ஐ நகலெடு",
        "verificationCode": "சரிபார்ப்பு குறியீடு",
        "codePlaceholder": "6 இலக்க குறியீட்டை உள்ளிடவும்"
      },
      "validation": {
        "fullNameRequired": "முழுப் பெயர் தேவை",
        "emailRequired": "சரியான மின்னஞ்சல் தேவை",
        "currentPasswordRequired": "தற்போதைய கடவுச்சொல் தேவை",
        "newPasswordTooShort": "கடவுச்சொல் குறைந்தது 8 எழுத்துகள் இருக்க வேண்டும்",
        "confirmPasswordRequired": "உங்கள் கடவுச்சொல்லை உறுதிப்படுத்தவும்",
        "passwordsMismatch": "கடவுச்சொற்கள் பொருந்தவில்லை"
      },
      "toasts": {
        "profileUpdated": "சுயவிவரம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
        "profileUpdateFailed": "சுயவிவரத்தை புதுப்பிக்க முடியவில்லை",
        "passwordChanged": "கடவுச்சொல் வெற்றிகரமாக மாற்றப்பட்டது",
        "passwordChangeFailed": "கடவுச்சொல்லை மாற்ற முடியவில்லை. உங்கள் தற்போதைய கடவுச்சொல்லை சரிபார்க்கவும்.",
        "mfaSetupFailed": "பல-காரணி அங்கீகார அமைப்பைத் தொடங்க முடியவில்லை",
        "mfaEnabled": "பல-காரணி அங்கீகாரம் இயக்கப்பட்டது",
        "mfaInvalidCode": "தவறான சரிபார்ப்பு குறியீடு",
        "avatarUpdated": "அவதார் புதுப்பிக்கப்பட்டது",
        "avatarUpdateFailed": "அவதார் புதுப்பிக்க முடியவில்லை",
        "avatarRemoved": "அவதார் அகற்றப்பட்டது",
        "avatarRemoveFailed": "அவதார் அகற்ற முடியவில்லை",
        "imageTooLarge": "படம் 4 MB-க்கு குறைவாக இருக்க வேண்டும்",
        "imageTooLargeServer": "படம் மிகப் பெரியது — சிறிய கோப்பை முயற்சிக்கவும்",
        "copiedToClipboard": "கிளிப்போர்டுக்கு நகலெடுக்கப்பட்டது"
      }
    }
  },
  "components": {
    "sessionTimeoutWarning": {
      "critical": "உங்கள் அமர்வு 1 நிமிடத்திற்கும் குறைவான நேரத்தில் காலாவதியாகும். உடனே உங்கள் வேலையை சேமிக்கவும்.",
      "expiringSoon_one": "உங்கள் அமர்வு {{count}} நிமிடத்தில் காலாவதியாகும்.",
      "expiringSoon_other": "உங்கள் அமர்வு {{count}} நிமிடங்களில் காலாவதியாகும்.",
      "extendButton": "அமர்வை நீட்டிக்க"
    }
  },
  "signInMethod": "Sign-in method",
  "signInPassword": "Password",
  "signInDirectory": "Directory",
  "signInSso": "SSO",
  "ldapDirectory": "Directory",
  "ldapLoading": "Loading directories…",
  "ldapEmpty": "No directories configured — contact your administrator.",
  "ssoEmail": "Work email",
  "ssoEmailPlaceholder": "you@hospital.org",
  "ssoContinue": "Continue with SSO",
  "ssoChecking": "Checking…",
  "ssoChoose": "Choose your sign-in provider",
  "ssoContinueWith": "Continue with {{name}}",
  "ssoNoneFound": "No SSO provider for this domain — try password or directory sign-in.",
  "ssoCallbackTitle": "Completing sign-in…",
  "ssoCallbackFailed": "Single sign-on failed",
  "ssoCallbackMissing": "Missing sign-in response — please try again.",
  "ssoBackToLogin": "Back to sign-in",
  "setup": {
    "title": "தொடக்க அமைப்பு",
    "subtitle": "இந்த நிறுவலுக்கான முதல் நிர்வாகி கணக்கை உருவாக்கவும்.",
    "username": "பயனர்பெயர்",
    "password": "கடவுச்சொல்",
    "confirmPassword": "கடவுச்சொல்லை உறுதிப்படுத்துக",
    "fullName": "முழு பெயர் (விருப்பம்)",
    "fullNamePlaceholder": "எ.கா.: குமார் பிரியா",
    "email": "மின்னஞ்சல் (விருப்பம்)",
    "submit": "நிர்வாகி கணக்கை உருவாக்குக",
    "submitting": "கணக்கு உருவாக்கப்படுகிறது…",
    "usernameHint": "3–64 எழுத்துகள்: சிறிய எழுத்துகள், இலக்கங்கள், புள்ளி, அடிக்கோடு, இடைக்கோடு.",
    "passwordHint": "குறைந்தது 12 எழுத்துகள்; பெரிய எழுத்து, சிறிய எழுத்து, இலக்கம், சிறப்பு எழுத்து இருக்க வேண்டும்.",
    "errUsername": "3–64 எழுத்துகளைப் பயன்படுத்துக: a–z, 0–9, புள்ளி, அடிக்கோடு அல்லது இடைக்கோடு.",
    "errPasswordLength": "கடவுச்சொல் குறைந்தது 12 எழுத்துகள் இருக்க வேண்டும்.",
    "errPasswordUpper": "கடவுச்சொல்லில் ஒரு பெரிய எழுத்து இருக்க வேண்டும்.",
    "errPasswordLower": "கடவுச்சொல்லில் ஒரு சிறிய எழுத்து இருக்க வேண்டும்.",
    "errPasswordDigit": "கடவுச்சொல்லில் ஒரு இலக்கம் இருக்க வேண்டும்.",
    "errPasswordSpecial": "கடவுச்சொல்லில் ஒரு சிறப்பு எழுத்து இருக்க வேண்டும்.",
    "errConfirmRequired": "கடவுச்சொல்லை உறுதிப்படுத்துக.",
    "errConfirmMismatch": "கடவுச்சொற்கள் பொருந்தவில்லை.",
    "errFullName": "முழு பெயர் 100 எழுத்துகளுக்கு மிகாமல் இருக்க வேண்டும்.",
    "errEmail": "சரியான மின்னஞ்சல் முகவரியை உள்ளிடுக.",
    "successTitle": "நிர்வாகி கணக்கு உருவாக்கப்பட்டது",
    "successBody": "“{{username}}” கணக்கு தயார். தொடர உள்நுழைக.",
    "goToLogin": "உள்நுழைவுக்குச் செல்க",
    "claimedTitle": "அமைப்பு ஏற்கனவே முடிந்துவிட்டது",
    "claimedBody": "இந்த அமைப்பில் ஏற்கனவே ஒரு நிர்வாகி உள்ளார். உங்கள் கணக்கில் உள்நுழைக.",
    "networkError": "சேவையகத்தை அணுக முடியவில்லை. இணைப்பைச் சரிபார்த்து மீண்டும் முயல்க.",
    "retry": "மீண்டும் முயல்க",
    "rateLimited": "அதிக முயற்சிகள். ஒரு நிமிடம் காத்திருந்து மீண்டும் முயல்க.",
    "usernameTaken": "இந்தப் பயனர்பெயர் ஏற்கனவே பயன்பாட்டில் உள்ளது.",
    "submitFailed": "கணக்கை உருவாக்க முடியவில்லை. மீண்டும் முயல்க."
  }
}
